<div class="toast ac-flex" (click)="open()">
  <div
    class="accent ac-flex ac-ctr"
    [style.background]="
      'linear-gradient(180deg, ' + data.color + ' 0%, ' + (data.color | darkenHexColor: 0.45) + ' 100%)'
    "
  >
    @if (data.logoUrl) {
      <img [src]="data.logoUrl" alt="" class="badge" />
    } @else {
      <ac-icon iconKey="hr:vip_level" [size]="24" />
    }
  </div>

  <div class="body ac-flex-col ac-gap-xs ac-pd-lg">
    <div class="ac-title-lg">{{ data.title }}</div>
    <div class="subtitle ac-body-md">{{ data.subtitle }}</div>
  </div>

  <button type="button" class="close ac-flex ac-ctr" aria-label="Dismiss" (click)="close($event)">
    <ac-icon iconKey="hr:xmark" [size]="14" />
  </button>
</div>
